export default "__VITE_ASSET__CTjBvu28__"